/** @format */

import React from 'react';

export const Greenline = () => {
	return <div className="greenline"></div>;
};
